// extracted by mini-css-extract-plugin
export default {"copy":"period-change-confirm-modal_copy__SwFVd","footerActions":"period-change-confirm-modal_footerActions__7X3W4"};